import GuidedPracticeList from './GuidedPracticeList';

export default GuidedPracticeList;
